/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { NO_MARGIN_BOTTOM } from '@constants';
import { SortableArrayField, TextField, ContentModuleModal, ColorField } from '@molecules';
import useEventColors from '@hooks/useEventColors';

import Form from '../Form';

import { FORM_FIELD, INITIAL_VALUES } from './constants';
import Item from './Item';
import AddArticleForm from './AddArticleForm';
import SlideItem from './SlideItem';
import s from './styles.module.less';

const Grid3x2 = ({ visible, onSubmit, hide, previewImg, onDelete, initialValues = INITIAL_VALUES, errors }) => {
  const [form] = Form.useForm(FORM_FIELD);
  const eventColors = useEventColors();

  const handleAddArticle = (article) => {
    form.setFieldsValue({
      [FORM_FIELD.SLIDES.name]: [...form.getFieldValue(FORM_FIELD.SLIDES.name), article],
    });
  };

  const handleClose = React.useCallback(() => {
    form.resetFields();
    hide();
  }, [form, hide]);

  const handleOk = React.useCallback(
    (values) => {
      onSubmit(values);
      handleClose();
    },
    [onSubmit, handleClose],
  );

  return (
    <ContentModuleModal
      visible={visible}
      title="Grid 3x2"
      subtitle={
        <>
          <div>Add articles to appear in a 3x2.</div>
          <div>You need to choose 6 articles.</div>
        </>
      }
      okText={onDelete ? 'SAVE CHANGES' : 'ADD GRID 3x2'}
      onCancel={handleClose}
      onSubmit={form.submit}
      onDelete={onDelete}
      heroImageSrc={previewImg}
      errors={errors}
    >
      <AddArticleForm onSubmit={handleAddArticle} />
      <Form form={form} layout="vertical" initialValues={initialValues} onSerializedFinish={handleOk}>
        <div className={s.slidesList}>
          <Form.WithFieldValue name={FORM_FIELD.SLIDES.name}>
            {() => (
              <SortableArrayField form={form} {...FORM_FIELD.SLIDES} withPlaceholder withCount>
                {(value) => <SlideItem slide={value} />}
              </SortableArrayField>
            )}
          </Form.WithFieldValue>
        </div>
        <ColorField {...FORM_FIELD.BACKGROUND_COLOR} mergeColors={eventColors} />
        <ColorField {...FORM_FIELD.TEXT_COLOR} />
        <TextField {...FORM_FIELD.TITLE} style={NO_MARGIN_BOTTOM} />
      </Form>
    </ContentModuleModal>
  );
};

Grid3x2.Item = Item;

export default Grid3x2;
